import { IEvent, IConsumer, ISubscriber, createConsumer, createSubscriber } from '@cian/events-log';
import { TThunkAction } from '../../types/redux';
import { getUser } from '../../thunk/user';
import { getTrackingUser } from '../../selectors/analytics';
import { ca } from '@cian/analytics';
import { IRequestAuthenticationParameters, TOPIC_USER } from './types';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export function subscribeOnAuthentification(parameters?: IRequestAuthenticationParameters): TThunkAction<() => void> {
  return (dispatch, getState) => {
    if (typeof window === 'undefined') {
      return () => undefined;
    }

    const consumer = getUserConsumer();
    let isSubscribed = true;
    const subscriberRef: { current?: ISubscriber } = {};
    const unsubscribe = () => {
      const subscriber = subscriberRef.current;

      if (isSubscribed && subscriber) {
        consumer.unsubscribe(subscriber);
        isSubscribed = false;
      }
    };
    const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
      if (event.type === 'authenticated') {
        if (getState().user.isAuthenticated) {
          unsubscribe();

          return;
        }

        await dispatch(getUser());

        ca(TOPIC_USER, getTrackingUser(getState()) as Record<string, unknown>);

        if (parameters && parameters.onSuccess) {
          dispatch(parameters.onSuccess());
        }

        unsubscribe();

        return;
      }

      if (event.type === 'authentication_modal_closed') {
        if (parameters && parameters.onCloseNoAuth) {
          dispatch(parameters.onCloseNoAuth());
        }

        unsubscribe();
      }
    });
    subscriberRef.current = userSubscriber;

    consumer.subscribe(userSubscriber);

    return unsubscribe;
  };
}
